import React from 'react';
import './contactus.css';

const ContactUs = () => {
  // Determine the appropriate map link based on the user's mobile platform.
  const getMapLink = () => {
    const query = encodeURIComponent("Shalamar Hospital, Lahore, Pakistan");
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      // For Android, use the geo URI (which most devices will pass to Google Maps)
      return `geo:0,0?q=${query}`;
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      // For iOS, using the Apple Maps URI scheme
      return `http://maps.apple.com/?q=${query}`;
    }
    // Otherwise, fallback to a Google Maps link in a new browser tab
    return `https://www.google.com/maps/search/?api=1&query=${query}`;
  };

  // The full map link to use when clicking the "Open Map" button
  const fullMapLink = getMapLink();

  return (
    <div className="contact-us">
      <h1>Contact Us</h1>
      <div className="contact-info">
        <p>
          Dr. Maryam Fatima, Shalamar Medical &amp; Dental College, Shalimar Link Road, Mughalpura, Lahore, Pakistan
        </p>
        <p>
          Email: <a href="mailto:conference@smdc.edu.pk">conference@smdc.edu.pk</a>
        </p>
        <p>
          Email: <a href="mailto:maryam.fatima@sihs.org.pk">maryam.fatima@sihs.org.pk</a>
        </p>
        <p>Tel: +92 42 3685 2660</p>
        <p>FAX: +92 42 3683 5555</p>
        <p>
          Website: <a href="http://www.smdc.edu.pk" target="_blank" rel="noopener noreferrer">www.smdc.edu.pk</a>
        </p>
        <p className="technical-assistance">
          For Technical Assistance Please Dial +92 334 876 1004 OR +92 111 205 205 Ext. 566
        </p>
      </div>
      
      <div className="map-container">
        {/* Interactive Google Map embed for Shalamar Hospital */}
        <iframe
          title="Shalamar Hospital Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3399.1381606307937!2d74.3772570765688!3d31.5752589444265!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39191ac9af9d7edf%3A0xa625f11332d699cb!2sShalamar%20Hospital!5e0!3m2!1sen!2s!4v1744178047561!5m2!1sen!2s"
          frameBorder="0"
          style={{ border: 0 }}
          allowFullScreen=""
          aria-hidden="false"
          tabIndex="0"
        ></iframe>
      </div>
      
      {/* Button overlay to open the map in a new tab or mobile maps app */}
      <div className="open-map-container">
        <button 
          className="open-map-btn"
          onClick={() => window.open(fullMapLink, "_blank")}
        >
          Open Map
        </button>
      </div>
    </div>
  );
};

export default ContactUs;
